import { TagForm as TagFormModel } from 'core/models';
import { tagService } from 'core/services';
import React from 'react';
import { useHistory } from 'react-router';
import TagForm from '../Form';

type Props = {
    backUrl: string;
};

const TagCreate: React.FC<Props> = ({ backUrl }) => {
    const history = useHistory();

    const onSubmit = (tag: TagFormModel) => {
        tagService.createTag(tag).then(() => history.push(backUrl));
    };

    return <TagForm backUrl={backUrl} onCreate={onSubmit}></TagForm>;
};

export default TagCreate;
